class saMobileApp {
    test = 1;
    is_app = false;
    is_android = false;
    is_ios = false;
    platform = null;
    nav_bar = {
        show() {},
        hide() {},
        set() {},
        define() {}
    }

    constructor() {}

    /**
     * @param {Object}  options
     * @param {Boolean} options.is_auth
     * @param {Boolean} options.is_provide_login_modal
     * @param {Boolean} options.is_ios
     * @param {Boolean} options.is_android
     * @param {Array}   options.templates
     * */
    init(options) {
        const that = this;

        // DOM
        const $html = $(document.documentElement);

        // VARS
        let platform = null;

        that.is_app = true;
        if (options.is_ios) {
            that.is_ios = true;
            platform = "ios";
        } else if (options.is_android) {
            that.is_android = true;
            platform = "android";
        }

        if (platform) {
            that.platform = platform;
            that.nav_bar = that.#initNavBar(options.templates['navigation']);

            that.#registerStart();

            $(document).ready( function() {
                that.nav_bar.show(null, false);
                that.nav_bar.define(false);
                if (options.is_auth || !options.is_provide_login_modal) {
                    enableVisibility();
                } else {
                    checkAuth().finally(enableVisibility);
                }
            });

        } else {
            $.sa.error("Mobile platform is not exist");
            enableVisibility();
        }

        function enableVisibility() {
            const prepare_class = 'is-prepare';
            $html.removeClass(prepare_class);
        }

        /**
         * @return {Promise}
         * */
        function checkAuth() {
            const animation_time = 500,
                  storage_name = "mobile_app_storage";

            let storage = sessionStorage.getItem(storage_name);
            storage = (storage ? JSON.parse(storage) : {});

            return new Promise( function(resolve, reject) {
                if (storage.auth_proposed) {
                    resolve();

                } else {
                    storage.auth_proposed = true;
                    sessionStorage.setItem(storage_name, JSON.stringify(storage));
    
                    $(".js-render-auth-modal:first").trigger("click");
                    setTimeout(resolve, animation_time);
                }
            });
        }
    }

    #initNavBar(html) {
        const that = this;

        const selectors = {
            'button': '.js-action-wrapper'
        };
        
        const classes = {
            show: 'fadeInUp',
            hide: 'fadeOutDown'
        }

        // DOM
        const $nav_bar = $(html),
              $nav_body = $nav_bar.find('.js-navigation-body');

        // CONST
        const sections = getSections($nav_bar);

        // VARS
        let is_active = false,
            active_section = null,
            hide_timeout = 0;

        $nav_bar.on('click', selectors.button, function(event) {
            const section_id = $(this).data('id');
            set(section_id);
        });

        return { show, hide, set, define };

        // Functions

        /**
         * @param {String?} section_id
         * @param {Boolean?} animate
         * */
        function show(section_id, animate = true) {
            if (!is_active) {
                is_active = true;

                // Останавливаем hide таймер
                clearTimeout(hide_timeout);

                // Добавляем навигацию если её нет в DOM
                if (!document.contains($nav_bar[0])) {
                    $nav_bar.appendTo(document.body);
                }

                // Анимация
                $nav_body.removeClass(classes.hide);
                if (animate) {
                    $nav_body.addClass(classes.show);
                }
            }
    
            if (typeof section_id === 'string') {
                set(section_id);
            }
        }

        /**
         * @param {Boolean?} animate
         * */
        function hide(animate = true) {
            if (!is_active) { return false; }
            is_active = false;

            $nav_body.removeClass(classes.show);
            if (animate) {
                $nav_body.addClass(classes.hide);

                hide_timeout = setTimeout( function() {
                    $nav_bar.detach();
                }, 500);

            } else {
                $nav_bar.detach();
            }
        }

        /**
         * @description Set active section by section_id
         * @param {String} section_id
         * */
        function set(section_id) {
            const active_class = 'is-active';

            if (active_section) {
                if (active_section.id === section_id) {
                    return false;

                } else {
                    active_section.$el.removeClass(active_class);
                    active_section = null;
                }
            }

            if (section_id && sections[section_id]) {
                active_section = sections[section_id];
                active_section.$el.addClass(active_class);
            }
        }

        /**
         * @description Определяем активную секцию и видимость кнопок на основе текущего URL страницы
         * @param {Boolean?} animate
         * */
        function define(animate = true) {

            defineActiveSection();
            displayVisibility();

            function defineActiveSection() {
                const current_url = location.origin + location.pathname;

                set("");

                Object.values(sections).forEach( function(section) {
                    if (section.url === current_url || (section.id !== 'home' && current_url.indexOf(section.url) !== -1)) {
                        set(section.id);
                        return false;
                    }
                });
            }

            function displayVisibility() {
                const url_parts = location.pathname.split("/").filter( value => !!value);

                // Поиск варианта
                if (url_parts[0] === 'search' && !!url_parts[1]) {
                    that.nav_bar.hide(animate);

                // Выбор пассажиров
                } else if (url_parts[0] === 'search' && url_parts[1] === 'passengers') {
                    that.nav_bar.hide(animate);

                // Заказ
                } else if (url_parts[0] === 'order' && url_parts[1] !== 'search') {
                    that.nav_bar.hide(animate);

                // Smartup
                } else if (url_parts[0] === 'smartup' && url_parts[1] === 'buy') {
                    that.nav_bar.hide(animate);

                // Иначе отображаем кнопки
                } else {
                    that.nav_bar.show(null, animate);
                }
            }
        }

        //
        function getSections($wrapper) {
            let result = {};

            $wrapper.find(selectors.button).each( function() {
                const $button = $(this);

                const section_id = $button.data('id');
                if (!section_id) { return }

                const url = $button[0].href;

                result[section_id] = {
                    $el: $button,
                    url: url,
                    id: section_id
                }
            });

            return result;
        }
    }
    
    /**
     * @description Проверяем зарегистрирован ли старт приложения в аналитике
     * */
    #registerStart() {
        const that = this,
              storage_name = "mobile_app_storage";

        let storage = localStorage.getItem(storage_name);
        storage = (storage ? JSON.parse(storage) : {});

        // Если метка о старте уже есть, выходим из выполнения
        if (storage.start_time) { return false; }

        storage.start_time = new Date().toJSON().slice(0, 19).replace("T", " ");
        localStorage.setItem(storage_name, JSON.stringify(storage));

        $.sa.analytics.reachGoal('mobile-app-first-open', {
            platform: that.platform,
            datetime: storage.start_time
        });
    }
}